import React from 'react';
import {Typography} from '@mui/material';
import {func, object} from 'prop-types';

import CollectionsAutocomplete from './CollectionsAutocomplete.jsx';
import {Accordion, AccordionDetails, AccordionSummary} from './Common.jsx';

const CollectionForm = ({collection, setCollection}) => {
  return (
    <Accordion defaultExpanded>
      <AccordionSummary>
        <Typography variant="subtitle2">Choose a feature collection</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <CollectionsAutocomplete value={collection} onChange={setCollection} />
      </AccordionDetails>
    </Accordion>
  );
};

CollectionForm.propTypes = {
  collection: object,
  setCollection: func,
};

export default CollectionForm;
